import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Controller } from "react-hook-form";
import OutlinedInput from '@mui/material/OutlinedInput';
import { FormHelperText } from '@mui/material';
import { checkboxStyle } from "../StyledComponent";
import { CustomDropdownIcon } from "../CustomDropDownIcon";

export const SelectTypeWithMarker = ({
    name,
    label,
    control,
    defaultValue,
    placeholder,
    children,
    errors,
    rules,
    height,
    width,
    endMarker,
    selectArray = [],
    ...props
}) => {
    return (

        <div className="flex flex-col gap-2 ">
            <FormControl sx={{ m: 1, minWidth: 120 }}>
                <label>{label}</label>
                <Controller
                    name={name}
                    control={control}
                    defaultValue={defaultValue}
                    rules={rules}
                    render={({ field }) =>
                        <Select
                            native={true}
                            {...field}
                            displayEmpty
                            label={label}
                            value={field.value || '0'}
                            input={<OutlinedInput sx={{ padding: 0, margin: 0 }}></OutlinedInput>}
                            sx={checkboxStyle}
                            style={{ width: width, height: height, borderRadius: '0.5rem' }}
                            className="py-2.5 "
                            IconComponent={CustomDropdownIcon}
                            MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                },
                            }}
                            menuPosition="bottom"
                            menuPlacement={"bottom"}
                            renderValue={
                                (selected) => {

                                    return (
                                        <div className="flex justify-between items-center text-base text-ellipsis text-[#70829B] truncate  font-normal w-full">
                                            <div class={` ${(selected || defaultValue) ? "text-black" : "text-[#70829B] "} overflow-hidden text-ellipsis  truncate  text-base font-normal leading-6 `}>
                                                {!selected && !defaultValue ? (placeholder) : (selected || defaultValue)}
                                            </div>
                                            <div className="flex">
                                                {endMarker}
                                            </div>
                                        </div>
                                    )
                                }
                            }
                        >
                            <option aria-label="None" value="" >
                                {placeholder}
                            </option>
                            {selectArray.map((item) => (
                                <option key={item} value={item}>
                                    {item} {endMarker}
                                </option>
                            ))}
                        </Select>

                    }
                />

                {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
            </FormControl>
        </div>
    );
};
